/* eslint-disable prefer-promise-reject-errors */
import { configureRefreshFetch } from 'refresh-fetch'

// @ts-ignore
import packageJson from '../../../package.json'
import { localStorageRefreshTokenKey, localStorageTokenKey } from '../entities/Authentication/Authentication'
import { fetchRefreshToken } from '../entities/Authentication/AuthenticationService'
import { isFetchResultSuccessful } from '../entities/FetchResult'

interface RequestInitExtraOptions extends RequestInit {
    disableContentType?: boolean;
}

const fetchWithToken = async (url: string, options?: RequestInitExtraOptions): Promise<Response> => {
    const apiToken = localStorage.getItem(localStorageTokenKey) || sessionStorage.getItem(localStorageTokenKey)

    // TENANT is sent even without a token: without it the API cannot tell which tenant database to use.
    const optionsWithToken: RequestInit = {
        ...options,
        headers: {
            Accept: 'application/vnd.api+json',
            ...(! options?.disableContentType && { 'Content-Type': 'application/vnd.api+json' }),
            ...options?.headers,
            TENANT: process.env.REACT_APP_TENANT || window.location.hostname,
            App: 'manager',
            'App-Version': packageJson.version,
            ...(apiToken && { Authorization: `Bearer ${apiToken}` }),
        },
    }

    const response = await fetch(url, optionsWithToken)

    if (response.status === 401) {
        return Promise.reject({
            response,
        })
    }

    return response
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const shouldRefreshToken = (error: any): boolean => error?.response?.status === 401

const updateRefreshToken = async (): Promise<void> => {
    const apiRefreshToken = localStorage.getItem(localStorageRefreshTokenKey) || sessionStorage.getItem(localStorageRefreshTokenKey)

    if (! apiRefreshToken) {
        throw new Error('No token found')
    }

    const refreshResponse = await fetchRefreshToken(apiRefreshToken)

    if (! isFetchResultSuccessful(refreshResponse)) {
        localStorage.removeItem(localStorageRefreshTokenKey)
        localStorage.removeItem(localStorageTokenKey)
        window.location.href = '/'

        throw new Error('Refresh token was invalid')
    }

    localStorage.setItem(localStorageTokenKey, refreshResponse.data.token)
    localStorage.setItem(localStorageRefreshTokenKey, refreshResponse.data.refresh_token)
}

export const authorizedFetch = configureRefreshFetch({
    fetch: fetchWithToken,
    refreshToken: updateRefreshToken,
    shouldRefreshToken,
})
/* eslint-enable prefer-promise-reject-errors */
